import { useEffect, useState } from "react";
import { _RecordProcess, _SignAndApprovalPanel } from "../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { PrintJson } from "../theme/Component/PrintJson";
import { _RecordDocumentTRD, _single } from "../../core/services/dataBean/EntityCatalog";
import { DocumentExp } from "./DocumentExp";
import useModal, { MODAL_md, MODAL_SM } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { AddDocumenExp } from "./AddDocumenExp";
import { toast } from "react-toastify";
import { Alert } from "../theme/Component/Alert";
import { RecordTypeSelect } from "../erp/cellEditor/RecordType/RecordTypeSelect";
import { SelectorProcessTypeConstants } from "../bpm/config/Componentes/SelectorProcessTypeConstants";
import { BasicButton } from "../theme/Component/BasicButton";
import { MultipleFileInput } from "../theme/Component/MultipleFileInput";
interface Props {
    typeExpediente: "DOCUMENTO" | "FLUJO" | "GENERAL";
    dataExpediente: any;
    isDocumentFactory?: boolean;
}
export const ExpedienteTRD = ({ typeExpediente = "GENERAL", dataExpediente, isDocumentFactory = false }: Props) => {

    const _sign = useDataBean(_SignAndApprovalPanel);
    const _recods = useDataBean(_RecordDocumentTRD);
    const { instance: _recodInstance, lista, setLista } = _recods;
    const [typeView, setTypeView] = useState<number>(0);
    const modalAdd = useModal("Agregar Documento", MODAL_md);
    const _recordProcess = useDataBean(_RecordProcess);
    const [expediente, setExpediente] = useState<any>({});
    const [exp, setExp] = useState<any>({});
    const [idProcess, setIDProcess] = useState<number>(0);
    const [key, setKey] = useState<number>(_single.getRandomInt());


    useEffect(() => {
        getDocs();
    }, [typeExpediente, dataExpediente])

    const getDocs = () => {
        // if (typeExpediente === "DOCUMENTO") 
        {
            setTypeView(0);
            if (dataExpediente.IDApprovaldocument > 0)
                getExpedientProcess({ IDApprovalDocument: dataExpediente.IDApprovaldocument });
            else if (dataExpediente.DocumentLocation > 0)
                getExpedientProcess({ YearRecord: getYearfromDate(dataExpediente.DocumentDate), IDDocument: dataExpediente.DocumentLocation, State: 1 });
        }
        modalAdd.close();
    }


    const getYearfromDate = (date: string) => {
        let year = _single.getCurrenYear();

        if (date) {

            let time = date.split("-");
            if (time.length > 0)
                year = parseInt(time[0]);
        }

        return year;
    }

    const getExpedientProcess = (props: any) => {

        _recordProcess.instance.getRecordProcessCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp.length > 0) {
                    setExpediente(resp[0].DataBeanProperties);
                } else {
                    toast.warning("Documento no tiene expediente.");
                    setExpediente({});
                }
            }
        )
    }



    const crearExpediente = () => {
        if (isDocumentFactory) {
            let bean = {
                TypeProcess: exp.idProcess,
                IDEmployee: dataExpediente.IDEmployee,
                State: 1,
                IDAccount: dataExpediente.IDEmployee,
                Mnemonic: dataExpediente.RecordDocName,
                YearRecord: _single.getCurrenYear(),
                MonthRecord: _single.getCurrentMonth(),
                IDRecordType: exp.idTypeRecord,
                Description: dataExpediente.RecordDocName,
                IDApprovalDocument: 0,
                IDDocument: dataExpediente.DocumentLocation

            }
            console.log(bean);
            _recordProcess.instance.makeRecordArchive(bean).then(
                (resp: any) => {
                    console.log(resp);

                    setExpediente(resp);
                }
            )
        }
        else {

            let bean = {
                TypeProcess: exp.idProcess,
                IDEmployee: _single.getAccountID(),
                State: 1,
                IDAccount: dataExpediente.IDAccount,
                Mnemonic: dataExpediente.Mnemonic,
                YearRecord: _single.getCurrenYear(),
                MonthRecord: 0,
                IDRecordType: exp.idTypeRecord,
                Description: dataExpediente.Mnemonic,
                IDApprovalDocument: dataExpediente.IDApprovaldocument

            }
            console.log(bean);
            _recordProcess.instance.makeRecordArchive(bean).then(
                (resp: any) => {
                    console.log(resp);

                    setExpediente(resp);
                }
            )
        }
    }

    const updateList = (docs: any) => {
        if (docs) {
            setKey(_single.getRandomInt());
            modalAdd.close();
        }
    }
    const updateListArray = (docs: any) => {
        if (docs) {
            setKey(_single.getRandomInt());
            modalAdd.close();
        }
    }

    return (
        <div className="row">
            {expediente.IDRecordProcess ?
                <>
                    <div className="col-md-12 mt-4">
                        <AddDocumenExp documents={null} idRecordProcess={expediente.IDRecordProcess} idProcessType={expediente.TypeProcess} onChange={updateList} />
                        {/* <button type="button" className="btn btn-primary btn-label waves-effect waves-light" onClick={() => { modalAdd.open() }}>
                            <i className="ri-file-add-line label-icon align-middle fs-16 me-2"></i>Agregar Documento</button> */}
                    </div>
                    <div className="col-md-12">
                        {typeView === 0 &&
                            <DocumentExp key={key} ID={expediente.IDRecordProcess} />
                        }
                    </div>

                </>
                :
                <>
                    <div className="col-md-12">
                        <fieldset>
                            <Alert clase="primary">
                                <strong>Expediente : </strong> No tiene un expediente para este documento desea crear uno ?.
                            </Alert>
                            <hr />
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectorProcessTypeConstants label="Proceso" idSelector={exp.idProcess} onChange={(e) => { setExp({ ...exp, "idProcess": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <RecordTypeSelect idSelector={exp.idTypeRecord} onChange={(e) => { setExp({ ...exp, "idTypeRecord": e }) }} />
                                </div>
                                <div className="col-md-6 mt-4">
                                    <BasicButton disable={!(exp.idProcess >= 0 && exp.idTypeRecord >= 0)} icon="" eventClick={crearExpediente}>Crear</BasicButton>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </>
            }

            <div className="col-md-12">
                <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} evenOnClose={getDocs}>
                    <AddDocumenExp documents={null} idRecordProcess={expediente.IDRecordProcess} idProcessType={expediente.TypeProcess} onChange={updateList} />
                </Modal>
            </div>
            {/* <div className="col-md-12">
                <PrintJson json={dataExpediente}/>
            </div> */}
        </div>
    )
}